import React, { ComponentType } from 'react';
import ErrorBoundary, { ErrorBoundaryConfig } from 'Components/ErrorBoundary';

const withErrorBoundary = <P extends Object>(boundaryProps: ErrorBoundaryConfig) => (Component: ComponentType<P>) => (props: P) => (
  <ErrorBoundary {...boundaryProps}>
    <Component {...props} />
  </ErrorBoundary>
);

export default withErrorBoundary;
